import { Box, Grid, Typography, Stack, Divider } from '@mui/material';
import PhoneIcon from '@mui/icons-material/Phone';
import EmailIcon from '@mui/icons-material/Email';
import ScheduleIcon from '@mui/icons-material/Schedule';
import { LOGO_IMAGE } from '../assets/logoImage';
import { GOLD, GOLD2, GOLDF, DARK } from '../theme/theme';

const QUICK_LINKS   = ['Home', 'About Us', 'Services', 'Projects', 'Gallery', 'Contact'];
const SERVICES      = ['DTCP Approval', 'Land Conversion', 'Layout Development', 'Joint Venture', 'NRI Desk', 'Legal Assistance'];
const CONTACT_ITEMS = [
  { Icon: PhoneIcon,    label: 'India', val: '+91 80560 10228' },
  { Icon: EmailIcon,    label: 'Email', val: 'info@elarisestates.com' },
  { Icon: ScheduleIcon, label: 'Hours', val: 'Mon–Sat · 9AM–7PM IST' },
];

export default function Footer() {
  return (
    <Box id="contact" component="footer" sx={{
      bgcolor: '#ffffff',
      borderTop: `3px solid ${GOLD}`,
      pt: 7, pb: 3, px: '5%',
    }}>
      <Grid container spacing={4} mb={4}>
        {/* Brand */}
        <Grid item xs={12} md={4}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 2 }}>
            <Box component="img" src={LOGO_IMAGE} alt="Elaris"
              sx={{ width: 52, height: 52, objectFit: 'cover', borderRadius: '8px', border: `2px solid ${GOLD}` }} />
            <Box>
              <Typography sx={{ fontFamily: "'Cinzel',Georgia,serif", fontWeight: 700, fontSize: '18px', letterSpacing: '0.10em', color: DARK, lineHeight: 1.1 }}>ELARIS</Typography>
              <Typography sx={{ fontFamily: 'Georgia,serif', fontStyle: 'italic', fontSize: '11px', color: GOLD }}>Estates</Typography>
            </Box>
          </Box>
          <Typography sx={{ color: '#5a4a2a', fontSize: 13, lineHeight: 1.8, mb: 1.5 }}>
            Premium residential plots, villas and apartments across Tamil Nadu, Malaysia and Singapore. 20 years of trust.
          </Typography>
          <Typography sx={{ fontSize: 12, color: '#7a6a4a', lineHeight: 1.8 }}>
            No.8 Thiyagigal Nagar, Varadharajapuram,<br />
            Near KSG College, Uppilipalayam Post,<br />
            Coimbatore – 641015<br />
            RERA: PRM/TN/RERA/1251/310/2024/003
          </Typography>
        </Grid>

        {/* Quick Links */}
        <Grid item xs={6} md={2}>
          <Typography sx={{ fontWeight: 700, fontSize: 11, letterSpacing: '0.15em', textTransform: 'uppercase', color: '#8a6000', mb: 1.75 }}>Quick Links</Typography>
          {QUICK_LINKS.map((l) => (
            <Typography key={l} component="a" href="#" sx={{ display: 'block', fontSize: 13, color: '#5a4a2a', mb: 1, textDecoration: 'none', '&:hover': { color: GOLD } }}>{l}</Typography>
          ))}
        </Grid>

        {/* Services */}
        <Grid item xs={6} md={2}>
          <Typography sx={{ fontWeight: 700, fontSize: 11, letterSpacing: '0.15em', textTransform: 'uppercase', color: '#8a6000', mb: 1.75 }}>Services</Typography>
          {SERVICES.map((l) => (
            <Typography key={l} component="a" href="#" sx={{ display: 'block', fontSize: 13, color: '#5a4a2a', mb: 1, textDecoration: 'none', '&:hover': { color: GOLD } }}>{l}</Typography>
          ))}
        </Grid>

        {/* Contact */}
        <Grid item xs={12} md={4}>
          <Typography sx={{ fontWeight: 700, fontSize: 11, letterSpacing: '0.15em', textTransform: 'uppercase', color: '#8a6000', mb: 1.75 }}>Contact</Typography>
          {CONTACT_ITEMS.map(({ Icon, label, val }, i) => (
            <Stack key={i} direction="row" spacing={1.25} mb={1.5} alignItems="flex-start">
              <Icon sx={{ fontSize: 14, color: GOLD2, mt: 0.3 }} />
              <Box>
                <Typography sx={{ fontSize: 11, fontWeight: 700, color: '#3a2a10' }}>{label}</Typography>
                <Typography sx={{ fontSize: 13, color: '#6a5a3a' }}>{val}</Typography>
              </Box>
            </Stack>
          ))}
        </Grid>
      </Grid>

      <Divider sx={{ borderColor: 'rgba(180,130,10,0.20)', mb: 2.5 }} />
      <Stack direction="row" justifyContent="space-between" flexWrap="wrap" gap={1}>
        <Typography sx={{ fontSize: 12, color: '#8a7a5a' }}>© 2025 ElarisEstates. All rights reserved.</Typography>
        <Typography sx={{ fontSize: 12, color: '#8a6800' }}>⬡ ISO 9001:2015 · RERA · Clear Title</Typography>
      </Stack>
    </Box>
  );
}
